const activity = {
  state: {
    currentmenu: '',
    status: '', // playing,stop
    activity: {}
  },

  mutations: {
    SET_CUR_MENU: (state, data) => {
      state.currentmenu = data
    },
    SET_CUR_ACT: (state, data) => {
      state.activity = data
      state.currentmenu = ''
    },
    RESET_CUR_MENU: (state) => {
      state.currentmenu = ''
      state.activity = {}
      state.status = ''
    }
  },

  actions: {
    setCurrentMenu({ state, commit }, data) {
      commit('SET_CUR_MENU', data)
    },
    setActivity({ state, commit }, data) {
      commit('SET_CUR_ACT', data)
    },
    clearCurrentMenu({ commit }) {
      commit('RESET_CUR_MENU')
    }
  }
}

export default activity



// WEBPACK FOOTER //
// ./src/store/modules/activity.js